"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import MainLayout from "@/app_views/MainLayout.vue";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import ElPhoneVerifyCodeInput from "../framework/components/form/ElPhoneVerifyCodeInput.vue";
import Validator from "../framework/components/form/validator";
import API from "@ym-framework/api-utils";
let BindWeiXin3 = class extends Vue {
  constructor() {
    super(...arguments);
    this.status = "ready";
    this.rules = {
      phone: [
        {
          required: true,
          message: "\u8D26\u53F7\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u786E\u8BA4\u540E\u518D\u6B21\u767B\u5F55\u3002",
          trigger: "blur"
        }
      ],
      password: [
        {
          required: true,
          message: "\u5BC6\u7801\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u786E\u8BA4\u540E\u518D\u6B21\u8F93\u5165\u3002",
          trigger: "blur"
        },
        {
          min: 6,
          max: 24,
          message: "\u5F53\u524D\u5BC6\u7801\u957F\u5EA6\u4E0D\u6B63\u786E\uFF0C\u5E94\u4E3A6\u523024\u4F4D",
          trigger: "blur"
        },
        { validator: Validator.password, trigger: "blur" }
      ]
    };
    this.formData = {
      phone: "",
      password: "",
      open_id: null
    };
    this.weixin = {
      code: null,
      state: -1,
      open_id: null,
      union_id: null,
      refresh_token: null,
      access_token: null
    };
    this.has_weixin_cookie = false;
  }
  created() {
    return __async(this, null, function* () {
      if (window.location.href.indexOf("?") !== -1) {
        var domine = window.location.href.split("?")[1].split("&");
        let obj = {};
        domine.forEach((item, i) => {
          let _item = item.split("=");
          obj[_item[0]] = _item[1];
        });
        const res = yield API.get(
          `api://base.app/api/v1/wechat/drainage/isBand/${obj.code}`
        );
        if (res.data.result) {
          this.$router.push({
            name: "BindWeiXinFail",
            params: { message: "\u5F53\u524D\u8D26\u53F7\u5DF2\u7ED1\u5B9A\u5176\u4ED6\u8D26\u53F7" }
          });
        }
      }
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        if (yield this._selfForm.validate()) {
          this.status = "submit";
          let params = {
            account: this.formData.phone,
            password: this.formData.password
          };
          if (window.location.href.indexOf("?") !== -1) {
            var domine = window.location.href.split("?")[1].split("&");
            let obj = {};
            domine.forEach((item, i) => {
              let _item = item.split("=");
              obj[_item[0]] = _item[1];
            });
            params.code = obj.code;
          }
          const responseBind = yield API.post(
            "api://base.app/api/v1/wechat/drainage/userBind",
            params
          );
          this.$router.push({
            name: "BindWeiXinSuccess",
            params: { message: responseBind.data.notice_message }
          });
          this.status = "ready";
        }
      } catch (error) {
        this.status = "ready";
        if (error.hasOwnProperty("response")) {
          this.$router.push({
            name: "BindWeiXinFail",
            params: { message: error.response.data.errors.datas[0].message }
          });
        }
      }
    });
  }
};
__decorateClass([
  Ref("selfForm")
], BindWeiXin3.prototype, "_selfForm", 2);
BindWeiXin3 = __decorateClass([
  Component({
    components: {
      MainLayout,
      PasswordInput,
      ElPhoneVerifyCodeInput
    }
  })
], BindWeiXin3);
export {
  BindWeiXin3 as default
};
